module.exports = __webpack_public_path__ + "assets/node_modules/@patternfly/react-user-feedback/dist/esm/images/rh_feedback.svg";